import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  for: "name",
  class: "form-label"
}
const _hoisted_3 = ["placeholder", "disabled", "readonly", "value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)




export default /*#__PURE__*/_defineComponent({
  __name: 'inputPrice',
  props: {
    modelValue: {
        type: Number,
        default: 0,
    },
    
    label: String,
    placeholder: {
        type: String,
        default: 'Enter price',
    },
    disabled: Boolean,
    readonly: Boolean,
    v: Object
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const handleInput = (event: any) => {
    let val = event.target.value;

    // Convert to float
    let num = parseFloat(val);

    // If NaN → emit empty or zero
    if (isNaN(num)) {
        emits('update:modelValue', '');
        return;
    }
 

    emits('update:modelValue', num);
};

const isFloat = (event: KeyboardEvent) => {
    const key = event.key;
    const currentValue = (event.target as HTMLInputElement).value;

    // Allow digits & one dot
    if (!/[\d.]/.test(key)) {
        event.preventDefault();
        return;
    }

    // Block second dot
    if (key === '.' && currentValue.includes('.')) {
        event.preventDefault();
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "text",
      placeholder: __props.label,
      disabled: __props.disabled,
      readonly: __props.readonly,
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (handleInput($event))),
      onKeypress: _cache[1] || (_cache[1] = ($event: any) => (isFloat($event))),
      class: "form-control"
    }, null, 40, _hoisted_3),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text-danger",
        key: error.$uid
      }, [
        _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
        _hoisted_4
      ]))
    }), 128))
  ]))
}
}

})